import { Id } from "@dgs/core";

export interface PaymentTransactionResource {
	id: Id;
	status: PaymentTransactionStatus;
}

export enum PaymentTransactionStatus {
	PENDING = "PENDING",
	COMPLETED = "COMPLETED",
	ERROR = "ERROR",
	CANCELLED = "CANCELLED",
}
